import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Archive({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2 -2 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.stroke}
          d="M1.592944 6.74464h31.90374-31.90374zm16.17 22.81686l-9.88152-9.88152h6.28848V12.1606h7.18608v7.51938h6.28848l-9.88152 9.88152zm15.34368-24.22596l-2.49744-3.01884c-.4851-.6105-1.22166-.98802-2.06646-.98802H6.983164c-.8448 0-1.58136.37752-2.08428.98802l-2.47962 3.01884c-.52074.6105-.82632 1.419-.82632 2.28162v22.45848c0 1.97604 1.617 3.59304 3.59304 3.59304h25.15392c1.97604 0 3.59304-1.617 3.59304-3.59304V7.61716c0-.86262-.30558-1.67112-.82632-2.28162z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

Archive.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
